import request from '@/utils/request'

export function getNotifications(params) {
  return request({
    url: '/api/system/notifications',
    method: 'get',
    params
  })
}

export function getNotificationDetail(id) {
  return request({
    url: `/api/system/notifications/${id}`,
    method: 'get'
  })
}

export function createNotification(data) {
  return request({
    url: '/api/system/notifications',
    method: 'post',
    data
  })
}

export function updateNotification(id, data) {
  return request({
    url: `/api/system/notifications/${id}`,
    method: 'put',
    data
  })
}

export function deleteNotification(id) {
  return request({
    url: `/api/system/notifications/${id}`,
    method: 'delete'
  })
}

export function batchDeleteNotifications(ids) {
  return request({
    url: '/api/system/notifications/batch',
    method: 'delete',
    data: ids
  })
}

export function markNotificationAsRead(id) {
  return request({
    url: `/api/system/notifications/${id}/read`,
    method: 'put'
  })
}

export function batchMarkNotificationsAsRead(ids) {
  return request({
    url: '/api/system/notifications/batch-read',
    method: 'put',
    data: ids
  })
}

export function batchMarkNotificationsAsUnread(ids) {
  return request({
    url: '/api/system/notifications/batch-unread',
    method: 'put',
    data: ids
  })
}

export function markAllNotificationsAsRead() {
  return request({
    url: '/api/system/notifications/read-all',
    method: 'put'
  })
}

export function getUnreadNotificationCount() {
  return request({
    url: '/api/system/notifications/unread-count',
    method: 'get'
  })
}

export function sendNotification(data) {
  return request({
    url: '/api/system/notifications/send',
    method: 'post',
    data
  })
}

export function getNotificationTemplates(params) {
  return request({
    url: '/api/system/notification-templates',
    method: 'get',
    params
  })
}

export function getNotificationTemplateDetail(id) {
  return request({
    url: `/api/system/notification-templates/${id}`,
    method: 'get'
  })
}

export function createNotificationTemplate(data) {
  return request({
    url: '/api/system/notification-templates',
    method: 'post',
    data
  })
}

export function updateNotificationTemplate(id, data) {
  return request({
    url: `/api/system/notification-templates/${id}`,
    method: 'put',
    data
  })
}

export function deleteNotificationTemplate(id) {
  return request({
    url: `/api/system/notification-templates/${id}`,
    method: 'delete'
  })
}

export function toggleNotificationTemplate(id, enabled) {
  return request({
    url: `/api/system/notification-templates/${id}/toggle`,
    method: 'put',
    data: { enabled }
  })
}

export function testNotificationTemplate(id, data) {
  return request({
    url: `/api/system/notification-templates/${id}/test`,
    method: 'post',
    data
  })
}

export function getNotificationChannels() {
  return request({
    url: '/api/system/notification-channels',
    method: 'get'
  })
}

export function updateNotificationChannelConfig(channel, config) {
  return request({
    url: `/api/system/notification-channels/${channel}`,
    method: 'put',
    data: config
  })
}

export function testNotificationChannel(channel, data) {
  return request({
    url: `/api/system/notification-channels/${channel}/test`,
    method: 'post',
    data
  })
}

export function getUserNotificationSettings() {
  return request({
    url: '/api/system/notification-settings/user',
    method: 'get'
  })
}

export function updateUserNotificationSettings(settings) {
  return request({
    url: '/api/system/notification-settings/user',
    method: 'put',
    data: settings
  })
}

export function getSystemNotificationSettings() {
  return request({
    url: '/api/system/notification-settings/system',
    method: 'get'
  })
}

export function updateSystemNotificationSettings(settings) {
  return request({
    url: '/api/system/notification-settings/system',
    method: 'put',
    data: settings
  })
}
